import script from "./QuizScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizScreen.vue?vue&type=script&setup=true&lang=ts"

import "./QuizScreen.vue?vue&type=style&index=0&id=74662c4e&lang=scss"

const __exports__ = script;

export default __exports__